/**
 * Autocomplete JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Autocomplete
 */
class Autocomplete {

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        // Search form desktop for autocomplete.
        this.searchFormDesktop  = $( '#site-main-searchform' );
        this.searchFormInput    = $( '#searchform__input' );
    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        this.searchAutocomplete();

    }

    /**
     * Search autocomplete.
     * Uses jQuery-ui autocomplete for the autocomplete.
     */
    searchAutocomplete() {

        /**
         * Set local data to search array results.
         * note: themeData is passed to javascript with wp-localize-script in Setup.php.
         */
        const searchArray = $.parseJSON( themeData.search_results );

        // Init jQuery autocomplete.
        $( '#searchform__input' ).autocomplete({
            source: function( request, response ) {
                var results = $.ui.autocomplete.filter( searchArray, request.term );
                response( results.slice( 0, 5 ) );
            },
            select: function( event, ui ) {

                // Prevent autocomplete from updating the textbox.
                event.preventDefault();

                // Manually update the textbox.
                jQuery( this ).val( ui.item.label );

                // Submit the form when a user selects an autocomplete suggestion
                // Using the cached element `this.searchFormDesktop` doesn't work here
                $( '#site-main-searchform' ).submit();
            },
            delay: 0,
            minLength: 3
        }).data( 'ui-autocomplete' )._renderItem = function( ul, data ) {
            const item = $( '<li class="ui-menu-item ui-menu-item-wrapper">' );

            item.append( data.label );

            item.appendTo( ul );

            return item;
        };
    };

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
    }
}

// Export the class reference.
module.exports = Autocomplete;



// WEBPACK FOOTER //
// ../vaasa/assets/scripts/autocomplete.js